<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper building" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal building">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div class="contentHeader unselectable">
							<div>
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Резиденция</span></span>
									<span class="level">
										(<span><span>Уровень {{gameModel.island.buildings.residence.level}}</span></span>)
									</span>
								</h2>
								<div class="buildingDescription">
									<span>Резиденция — это небольшой особняк, где останавливается король во время своих визитов. Помимо выполнения других функций, резиденция защищает деревню от захвата врагами.</span>
								</div>
								<img class="buildingHuge buildingType25 tribeId3 level10" src="//iwstatic.g.bsrv.su/img/x.gif" />
							</div>
							<span class="buildingStatusButton type_15">
								<div class="buildingStatus location27 optionMenu">
									<div class="buildingBubble clickable disabledHover">
										<div class="colorLayer notNow enoughRes">
											<div class="labelLayer">
												<span class="buildingLevel">10</span>
											</div>
										</div>
									</div>
								</div>
							</span>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<nav class="tabulation maintab unselectable">
									<a class="tab clickable" :class="{active: tab == 'expansions', inactive: tab != 'expansions'}" @click="onToggleTab('expansions')">
										<div class="content">
											<span>Экспансия</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'culturePoints', inactive: tab != 'culturePoints'}" @click="onToggleTab('culturePoints')">
										<div class="content">
											<span>Единицы культуры</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'acceptance', inactive: tab != 'acceptance'}" @click="onToggleTab('acceptance')">
										<div class="content">
											<span>Одобрение</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'capital', inactive: tab != 'capital'}" @click="onToggleTab('capital')">
										<div class="content">
											<span>Столица</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable tabContent">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div ng-transclude="">
													<div ng-controller="buildingIndexCtrl" class="building buildingType25" ng-class="{buildingResourceProduction: building.data.buildingType <= 4}">
														<div ng-include="" src="pageTemplate">
															<div class="buildingDetails palace" ng-controller="palaceCtrl">
																<div ng-show="isBuildingBuild()">
																	<div class="palaceBody">
																		<div class="loadedTab currentTab" v-if="tab == 'expansions'">
																			<expansions />
																		</div>
																		<div class="loadedTab currentTab" v-if="tab == 'culturePoints'">
																			<culture-points />
																		</div>
																		<div class="loadedTab currentTab" v-if="tab == 'acceptance'">
																			<acceptance />
																		</div>
																		<div class="loadedTab currentTab" v-if="tab == 'capital'">
																			<capital />
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Expansions from '@/components/pages/buildings/residence/Expansions';
import CulturePoints from '@/components/pages/buildings/residence/CulturePoints';
import Acceptance from '@/components/pages/buildings/residence/Acceptance';
import Capital from '@/components/pages/buildings/residence/Capital';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Резиденция | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		tab: 'expansions',
		
		villageBackgroundLeft: '0px',
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab, push = true){
			this.tab = tab;
			if(push) this.$router.push({query: {tab}});
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: {tab: 'expansions'}});
		else if(to.query.tab != this.tab) this.onToggleTab(to.query.tab, false);
		next();
	},
	created(){
		this.gameModel.buildingQueue.show = true;
	},
	components: {
		Expansions,
		CulturePoints,
		Acceptance,
		Capital,
	},
}
</script>